"use strict";
/**
 * Skinny entry point.
 *
 * Keep this file as small as possible — it's the very first JS the
 * browser parses, and every byte here delays first paint of the React
 * tree. All heavy imports (MSAL, React Router, the App component graph)
 * live in `./bootstrap` and are loaded in a separate chunk, so the
 * inline "Loading…" placeholder rendered by template.html is actually
 * visible to the user while the app chunk downloads.
 */
const rootEl = document.getElementById('root');
import(/* webpackChunkName: "app-bootstrap" */ './bootstrap')
    .then(({ bootstrap }) => bootstrap(rootEl))
    .catch((err) => {
    // Last-resort error UI if the bootstrap chunk itself fails to load
    // (e.g. network blip on a CDN). Avoid leaving the user staring at
    // the inline "Loading…" forever.
    console.error('Failed to load application bootstrap chunk', err);
    rootEl.innerHTML = `
            <div style="display:flex;align-items:center;justify-content:center;height:100vh;
                        font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;color:#254056;
                        background:linear-gradient(135deg,#e9f0ee 0%,#f2f3f7 100%);text-align:center;padding:24px;">
                <div>
                    <h2 style="margin:0 0 8px 0;">Couldn't load the application</h2>
                    <p style="margin:0 0 16px 0;color:#5a6b7a;">Please check your connection and refresh the page.</p>
                    <button onclick="location.reload()" style="padding:10px 22px;border-radius:6px;border:none;
                            background:#2e7d32;color:#fff;font-size:1rem;cursor:pointer;">Reload</button>
                </div>
            </div>`;
});
